/* Sidekick PDP: variant selection, price sync, sticky bar add-to-cart, callout toggles. */
(function () {
  'use strict';

  var jsonEl = document.querySelector('[data-product-json]');
  if (!jsonEl) return;

  var product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }

  var form = document.getElementById('pdp-form');
  var idInput = document.querySelector('[data-variant-id]');
  var priceEl = document.querySelector('[data-price]');
  var compareEl = document.querySelector('[data-compare-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var atc = document.querySelector('[data-atc]');
  var stickyAtc = document.querySelector('[data-sticky-atc]');

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
  var fmt = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: currency,
    maximumFractionDigits: 0
  });

  function money(cents) {
    return fmt.format(cents / 100);
  }

  function selectedOptions() {
    var opts = [];
    document.querySelectorAll('[data-option-input]:checked').forEach(function (input) {
      opts[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
    });
    return opts;
  }

  function findVariant(opts) {
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function sync() {
    var variant = findVariant(selectedOptions()) || product.variants[0];
    if (!variant) return;

    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (stickyPrice) stickyPrice.textContent = money(variant.price);

    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var soldOutLabel = atc && atc.getAttribute('data-soldout-label');
    var addLabel = atc && atc.getAttribute('data-add-label');
    if (atc) {
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? addLabel : soldOutLabel;
    }
    if (stickyAtc) stickyAtc.disabled = !variant.available;

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  if (atc) {
    atc.setAttribute('data-add-label', atc.textContent.trim());
    atc.setAttribute('data-soldout-label', atc.getAttribute('data-soldout') || 'Sold out');
  }

  document.querySelectorAll('[data-option-input]').forEach(function (input) {
    input.addEventListener('change', sync);
  });

  if (stickyAtc && form) {
    stickyAtc.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    });
  }

  /* Callout dots: tap-to-toggle for touch, hover handled by CSS */
  document.querySelectorAll('[data-callout-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-callout-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      btn.setAttribute('aria-expanded', String(!open));
    });
  });

  sync();
})();
